import React from "react";
import YouTube from "react-youtube";
// import ContentBlock from "../../../sections/ContentBlock/ContentBlock";
// import FadeInSection from "../../../sections/FadeIn/FadeIn";

import "./Story.css";

const story = () => {
  return (
    <div>
      {/* <Banner
        img_src="https://districttrack.s3.us-east-2.amazonaws.com/assets/media/DTC/team.jpg"
        img_alt="Our Team"
      >
        <h1>Our Story</h1>
      </Banner> */}
      <section>
        <YouTube videoId="5n8ZCTgkWLo" containerClassName="OurStory" />
        <p className="b">
          Produced by: <a href="https://www.elevation0m.com/">Elevation 0m</a>
        </p>
      </section>
    </div>
  );
};

export default story;
